import { fetchApi, getFetchApiJSONResponse, catchFetchApiError } from 'shared/functions';

type UploadCustomCompaniesParams = {
  companiesFile: File;
  organisationId: string;
  isPortfolioManager?: boolean;
  portfolioId?: string;
};

export const uploadCustomCompanies = async ({
  companiesFile,
  organisationId,
  isPortfolioManager,
  portfolioId,
}: UploadCustomCompaniesParams) => {
  const formData = new FormData();
  formData.append('file', companiesFile, companiesFile.name);

  if (!portfolioId) {
    formData.append('organisationId', organisationId);
  }

  const params = {
    method: 'POST',
    body: formData,
  };

  const url = isPortfolioManager
    ? `/user-profile/portfolios/upload-custom-company/${portfolioId}`
    : '/esg/api/upload-custom-company/';

  return fetchApi(url, params, ['Content-Type'])
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};
